// extracted by mini-css-extract-plugin
export default {"paginatedListContainer":"PaginatedList_paginatedListContainer__Xu-R5","itemList":"PaginatedList_itemList__Zy6Yl","seeMoreContainer":"PaginatedList_seeMoreContainer__hKcLU"};